import React from "react";
import { Button, CircularProgress } from "@mui/material";
import styles from "../QuoteMultipleDestinationsPanel.module.css";
import RailIconFO from "../../../icons/RailIconFO";
import { TruckIconFO } from "../../../icons";

export type PricePreference = {
  truck: "px" | "alt";
  rail: "px" | "alt";
};

type Props = {
  mode: PricePreference;
  setMode: (nextMode: PricePreference) => void;
  isSaving?: boolean;
  originManager?: boolean;
};

export const KochDlvdOfferToggle: React.FC<Props> = ({
  mode,
  setMode,
  isSaving = false,
  originManager = false,
}) => {
  return (
    <div className={styles.kochDlvdOfferContainer}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span className={styles.kochDlvdOfferLabel}>KOCH DLVD OFFER</span>
        {isSaving && <CircularProgress size={12} />}
      </div>
      <div className={styles.kochDlvdToggleRow}>
        <div id="truck-toggle-group" className={styles.kochDlvdToggleGroup}>
          <TruckIconFO size={originManager ? "20" : "14"} color="#60a5fa" />
          <Button
            id="truck-px-button"
            disableRipple
            disabled={isSaving}
            onClick={() => setMode({ ...mode, truck: "px" })}
            className={`${styles.kochToggleButton} ${
              mode.truck === "px" ? styles.kochToggleButtonActive : ""
            }`}
          >
            Px
          </Button>
          <Button
            id="truck-alt-button"
            disableRipple
            disabled={isSaving}
            onClick={() => setMode({ ...mode, truck: "alt" })}
            className={`${styles.kochToggleButton} ${
              mode.truck === "alt" ? styles.kochToggleButtonActive : ""
            }`}
          >
            ALT
          </Button>
        </div>
        <div id="rail-toggle-group" className={styles.kochDlvdToggleGroup}>
          <RailIconFO size={originManager ? "20" : "14"} color="#f97316" />
          <Button
            id="rail-px-button"
            disableRipple
            disabled={isSaving}
            onClick={() => setMode({ ...mode, rail: "px" })}
            className={`${styles.kochToggleButton} ${
              mode.rail === "px" ? styles.kochToggleButtonActive : ""
            }`}
          >
            Px
          </Button>
          <Button
            id="rail-alt-button"
            disableRipple
            disabled={isSaving}
            onClick={() => setMode({ ...mode, rail: "alt" })}
            className={`${styles.kochToggleButton} ${
              mode.rail === "alt" ? styles.kochToggleButtonActive : ""
            }`}
          >
            ALT
          </Button>
        </div>
      </div>
    </div>
  );
};
